import { CheckCircle2Icon, Loader2Icon } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { userService } from '../services/userService';
import { useNavigate } from 'react-router-dom';

export default function VerifyResetPasswordPage() {
  const navigate = useNavigate();
  const runningEffect = useRef<boolean>(false);

  const [verifying, setVerifying] = useState<boolean>(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    if (runningEffect.current) return;
    runningEffect.current = true;

    const searchParams = new URLSearchParams(window.location.search);
    const token = searchParams.get('token');

    console.log('token', token);

    if (!token) {
      console.error('Missing token or email');
      return;
    }

    userService
      .verifyResetPasswordRequest(token)
      .then(console.log)
      .catch((error) => {
        console.log('error:', error);
        setError(error.message);
      })
      .finally(() => setVerifying(false));
  }, []);

  useEffect(() => {
    if (verifying) {
      return;
    }
    if (!error) {
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    }
  }, [verifying, error]);

  return (
    <div className="min-h-screen min-w-screen flex flex-col items-center justify-center gap-4">
      <span>
        {verifying ? (
          <Loader2Icon className="w-10 h-10 animate-spin" />
        ) : error ? null : (
          <CheckCircle2Icon className="w-10 h-10 fill-green-600" />
        )}
      </span>
      <span className={verifying ? '' : error ? 'text-red-600' : 'text-green-600'}>
        {verifying
          ? 'Resetting your password...'
          : error
            ? error
            : 'Success! You will receive an email with the new password. Redirecting to the login page...'}
      </span>
    </div>
  );
}
